<template>
  <div class="header-title-container">
    <big-title class="dark-green">
      {{ mainTitle }}
    </big-title>
    <tooltip-custom v-if="btnInfo && btnInfo?.disabled"
                    :label-text="btnInfo?.disabledText">
      <button-main :disabled="true"
                   @click="btnInfo.action()">
        {{ btnInfo.text }}
      </button-main>
    </tooltip-custom>
    <button-main v-else-if="btnInfo"
                 @click="btnInfo.action()">
      {{ btnInfo.text }}
    </button-main>

    <div class="right-container" v-else>
      <slot/>
    </div>
  </div>
</template>

<script>
import BigTitle from "@/components/shared/text/BigTitle.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import TooltipCustom from "@/components/shared/TooltipCustom.vue";

export default {
  name: "HeaderTitle",
  components: {TooltipCustom, ButtonMain, BigTitle},
  props: {
    mainTitle: {
      type: String,
      required: true
    },
    btnInfo: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
.header-title-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  @media(max-width: 769px) {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 8px;
  }
  .right-container {
    max-width: 200px;
    width: 100%;
  }

}
</style>